import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Box from 'components/Box';

const INPUT_STYLE = { display: 'none' };

class FileInput extends PureComponent {
  static propTypes = {
    name: PropTypes.string,
    children: PropTypes.func.isRequired,
    accept: PropTypes.string,
    onFileAdded: PropTypes.func.isRequired,
    onFileRemoved: PropTypes.func,
    readDataAsUrl: PropTypes.bool,
  };

  state = { fileName: '' };

  handleClick = () => this.input.click();

  handleFileChange = e => {
    // TODO: consider adding file validations a'la file_validation.js

    if (!e.target.files[0]) {
      return;
    }

    if (this.props.readDataAsUrl) {
      // React cannot store File/Blob objects in state.
      // Instead, use FileReader so it can be stored in state as a base64 string.
      this.encodeFile(e);
    } else {
      this.props.onFileAdded(e);
    }

    this.updateFileName();
  };

  encodeFile = e => {
    const reader = new FileReader();

    reader.onload = () => {
      this.props.onFileAdded(reader.result);
    };

    reader.readAsDataURL(e.target.files[0]);
  };

  updateFileName = () => {
    const filePath = this.input.value;
    const fileName = filePath.substring(filePath.lastIndexOf('\\') + 1);

    this.setState({ fileName });
  };

  handleRemoveFile = e => {
    e.preventDefault();

    this.setState({ fileName: '' });
    this.input.value = null;

    if (this.props.onFileRemoved) {
      return this.props.onFileRemoved();
    }
  };

  setInputRef = input => (this.input = input);

  render() {
    const { fileName } = this.state;
    const { name, children, accept } = this.props;

    return (
      <Box>
        {children({
          fileName,
          handleClick: this.handleClick,
          handleRemoveFile: this.handleRemoveFile,
        })}

        <input
          name={name}
          type="file"
          accept={accept}
          ref={this.setInputRef}
          style={INPUT_STYLE}
          onChange={this.handleFileChange}
        />
      </Box>
    );
  }
}

export default FileInput;
